module.exports = __webpack_public_path__ + "static/img/blog-10.c527821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-10.jpg
// module id = QgXW
// module chunks = 7